<template>
	<Page class="">
		<template v-slot:content>
			<div class="top">
				<SafeAreaTop :showClose="false" class="absolute"> </SafeAreaTop>
				<img class="promo" src="@/assets/pre/92_off.png" alt="" />
			</div>

			<div class="container">
				<div class="title">Unlimited Access at 40% off, this year, next year, and forever</div>
			</div>
		</template>

		<template v-slot:footer>
			<div class="container">
				<div class="">
					<button @click="goNext" class="btn btn-block btn-primary">Next</button>
				</div>
			</div>
		</template>
	</Page>
</template>

<script>
import { inject, onMounted } from 'vue'
import { useRouter } from 'vue-router'
import Page from '@/components/Page'
import SafeAreaTop from '@/components/SafeAreaTop'
import { useStore } from 'vuex'

export default {
	components: {
		Page,
		SafeAreaTop
	},

	setup() {
		const amplitude = inject('amplitude')
		const router = useRouter()
		const store = useStore()

		const close = (Status = 'Close', query = {}) => {
			amplitude.logEvent('Pre Paywall - Close', {
				Layout: 'Offer 92% off',
				From: store.getters['getSource'],
				Step: 'Pre Paywall',
				Status
			})
			router.push({
				name: 'offer-40off-paywall',
				query
			})
		}

		const goNext = () => close()

		onMounted(() => {
			amplitude.logEvent('Pre Paywall - Show', {
				Layout: 'Offer 92% off',
				Step: 'Pre Paywall',
				From: store.getters['getSource']
			})
			amplitude.logEvent(store.getters['getAmplitudeEventName']('PrePaywallShow'))
		})

		return {
			goNext
		}
	}
}
</script>

<style lang="scss" scoped>
.top {
	position: relative;
}
.promo {
	max-width: 530px;
	margin-left: auto;
	margin-right: auto;
	width: 100%;
	display: block;
}
.title {
	color: #654c93;
	font-weight: 900;
	font-size: 2.2rem;
	text-align: center;
	line-height: 1.3;
	margin-top: 5vh;
}
.absolute {
	position: absolute;
	top: 0;
	left: 0;
	z-index: 2;
	width: 100%;
}
</style>
